

module.exports = __webpack_require__.stylable.create(
    "o11",
    {"classes":{"root":"s292","pre":"s293","paragraph":"s294","title1":"s295","title2":"s296","title3":"s297","title4":"s298","title5":"s302","title6":"s303","underline":"s299","basicList":"s300","basicListItem":"s301"},"vars":{"color-mdx-code":"--o0-color-mdx-code","base-font":"--o0-base-font","color-secondary-dark":"--o0-color-secondary-dark","color-secondary-light":"--o0-color-secondary-light","color-mdx-pre-bg":"--o0-color-mdx-pre-bg","shadow-1":"--o0-shadow-1","base-line-height":"--o11-base-line-height"},"stVars":{},"keyframes":{}},
    "",
    2,
    1,
    null
);
